/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from "react";
import { Text } from "@chakra-ui/react";
import {
  FormInputGroup,
  InputFake,
  LabeFormlStyled
} from "styled/Input.styled";
import { ButtonStyled } from "styled/Buttons.styled";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import { __ShowTypeZf } from "request/configuration/TypeZf";
import { useSelector } from "react-redux";

const FormTypeZFShow = () => {
  const initialForm = {
    name_typeFreeZone: "",
    description_typeFreeZone: "",
    status_typeFreeZone: ""
  };
  const [form, setForm] = useState(initialForm);
  const { onCloseModal, dataToShow } = useContext(ConfigurationCRUDContext);
  const token = useSelector((state) => state.auth.dataUser.token);

  useEffect(() => {
    if (dataToShow) {
      const initialpos = async () => {
        try {
          const res = await __ShowTypeZf(token, dataToShow.id);
          setForm(res?.data?.status?.data);
        } catch (error) {}
      };
      initialpos();
    } else {
      setForm(initialForm);
    }
  }, [dataToShow]);
  return (
    <>
      <Text
        fontSize="xl"
        mb={3}
        style={{
          fontWeight: 600,
          borderBottom: "1px solid #bababa80",
          paddingBottom: "1rem"
        }}
      >
        {dataToShow ? form.name_typeFreeZone : ""}
      </Text>
      <form action="">
        <div className="row">
          <div className="row">
            <div className="col-md-6">
              <FormInputGroup>
                <LabeFormlStyled>Nombre tipo de transporte </LabeFormlStyled>
                <InputFake>{form.name_typeFreeZone}</InputFake>
              </FormInputGroup>
            </div>
            <div className="col-md-6">
              <FormInputGroup>
                <LabeFormlStyled>
                  Descripción tipo de transporte
                </LabeFormlStyled>
                <InputFake>
                  {form.description_typeFreeZone === null
                    ? "---"
                    : form.description_typeFreeZone}
                </InputFake>
              </FormInputGroup>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <FormInputGroup>
              <LabeFormlStyled>Estado</LabeFormlStyled>
              <InputFake>
                {form.status_typeFreeZone === 1 ? "Activo" : "Inactivo"}
              </InputFake>
            </FormInputGroup>
          </div>
        </div>
        <div className="d-grid gap-2 d-md-flex justify-content-md-end">
          <ButtonStyled type="button" wd="140px" onClick={onCloseModal}>
            Aceptar
          </ButtonStyled>
        </div>
      </form>
    </>
  );
};

export default FormTypeZFShow;
